import { Suspense, useEffect, useRef, useState, type ReactNode } from 'react'

// Monta uma secção só quando está perto de entrar no ecrã (07/10/2026).
// Na página inicial, montar todas as secções de uma vez ocupava o telemóvel
// ~0,9s logo no arranque (Lighthouse, site real), atrasando os toques em
// "Pedir um serviço". Até montar, fica um espaço com a altura aproximada,
// para a página não saltar.
//
// Monta logo (sem esperar) quando: o URL tem âncora (#faq…), é um robô de
// pesquisa (o Google tem de ver o conteúdo todo) ou não há IntersectionObserver.

const ROBO = /bot|crawler|spider|googlebot|bingbot|duckduckbot|yandex|facebookexternalhit|whatsapp/i

function montarJa(): boolean {
  if (typeof window === 'undefined') return true
  return !!window.location.hash || ROBO.test(navigator.userAgent) || typeof IntersectionObserver === 'undefined'
}

interface Props {
  children: ReactNode
  /** Altura reservada antes de montar (px), aproximada à da secção. */
  altura: number
  /** Distância ao ecrã a partir da qual começa a montar. */
  margem?: string
  id?: string
}

export function MontarQuandoPerto({ children, altura, margem = '600px 0px', id }: Props) {
  const ref = useRef<HTMLDivElement>(null)
  const [montado, setMontado] = useState(montarJa)

  useEffect(() => {
    if (montado || !ref.current) return
    const obs = new IntersectionObserver(
      (entradas) => {
        if (entradas.some((e) => e.isIntersecting)) {
          setMontado(true)
          obs.disconnect()
        }
      },
      { rootMargin: margem },
    )
    obs.observe(ref.current)
    return () => obs.disconnect()
  }, [montado, margem])

  const reserva = <div style={{ minHeight: altura }} aria-hidden="true" />
  return (
    <div ref={ref} id={id}>
      {montado ? <Suspense fallback={reserva}>{children}</Suspense> : reserva}
    </div>
  )
}
